import type { IconSvgObject } from './types';

const BitcoinIcon: IconSvgObject = [
  ["path", { d: "M6 5H14.5C16.433 5 18 6.567 18 8.5C18 10.433 16.433 12 14.5 12M6 19H14.5C16.433 19 18 17.433 18 15.5C18 13.567 16.433 12 14.5 12M14.5 12H7.2001M7.0001 5V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 3V5M13.5 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 19V21M13.5 19V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BitcoinIcon;
